module.exports = __webpack_public_path__ + "img/m_ban2.d30b0cd5.png";